import React, { Component } from 'react';
import '../App.css';
/* global $ */
/* global grecaptcha */
/* global grec_ready */

export default class Login extends Component {  
  componentDidMount(){
    let grec_promise = new Promise((resolve, reject) => {
      function check_grec() {
        if (!grec_ready) {
          setTimeout(check_grec, 50);
          return;
        }
        // grecaptcha is ready
        resolve();
      }
      check_grec();
    });
    grec_promise.then(() => {
      widget_id = grecaptcha.render('sure', {
          'sitekey' : '6LdDyl8UAAAAAMmSSzFS29e-Jda0oneqA30CieP4',
          'theme' : 'light'
        });  
    });
    
    $('#login_modal').on('hidden.bs.modal', function () {
      $('#login_pass').val('');
      $('#login_email').val('');
      grec_promise.then(() => {
        grecaptcha.reset(widget_id);
      });
      if (window.location.hash.substring(1) === 'login')
        window.history.pushState("", document.title, window.location.pathname
                                                        + window.location.search);
    })
  }
  
  login_submit() {
    let firebase = this.props.app_state.firebase;
    if ($('#login_pass').val().length === 0) {
      return $('#alert_danger').text('Please enter your password').fadeIn().delay(1500).fadeOut();
    }
    if ($('#login_email').val().length === 0) {
      return $('#alert_danger').text('Please enter your email address').fadeIn().delay(1500).fadeOut();
    }
    
    $('#alert_working').fadeIn().delay(3000).fadeOut();
    let token = grecaptcha.getResponse(widget_id);
    
    $.post('https://us-central1-minusthenegative-1fd3c.cloudfunctions.net/cap', 
          {'token': token})
      .then((res) => {
        if (JSON.parse(res)['success'] === false) {
          $('.alert').fadeOut();
          return $('#alert_danger').text('Recaptcha Failed').fadeIn().delay(1800).fadeOut();
        }
        if (document.querySelector('#click_me').checked) {
          return;
        }
        
        firebase.auth()
          .signInWithEmailAndPassword($('#login_email').val(), $('#login_pass').val())
          .then(() => {
            $('#login_modal').modal('hide');
            $('.alert').fadeOut();
            $('#alert_dark').text('You are logged in').fadeIn().delay(1800).fadeOut();
            grecaptcha.reset(widget_id);
            return;
          })
          .catch(function(error) {
            grecaptcha.reset(widget_id);
            $('.alert').fadeOut();
            $('#alert_danger').text(error.message).fadeIn().delay(1800).fadeOut();
            return;
          });
      });
  }
  
  forgot_pw() {
    let firebase = this.props.app_state.firebase;
    let email = $('#login_email').val();
    if (email === ''){
      $('#alert_danger').text('Please enter your email address first')
                                          .fadeIn().delay(1600).fadeOut();
      return;
    }
    $('#alert_working').fadeIn().delay(1800).fadeOut();
      
    firebase.auth().sendPasswordResetEmail(email).then(function() {
      $('.alert').fadeOut();
      $('#alert_dark').text('Reset link sent to your email')
                                  .fadeIn().delay(1600).fadeOut();
    }).catch(function(error) {
      $('.alert').fadeOut();
      $('#alert_danger').text(error.message)
                          .fadeIn().delay(1600).fadeOut();
      console.log(error);
    });
    
    $('#login_email').val('');
  }
  
  render() {
    return (
      <div id="login_modal" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Login</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            <t style={{'marginTop': '15px'}}>E-mail</t>
            <input id="login_email" type="email"
                                    placeholder="Please enter your email address" 
                                    className="form-control" name="email"></input>
            <t style={{'marginTop': '10px'}}>Password</t>
            <input id="login_pass" placeholder="Please enter your password" 
                                   className="form-control" type="password"
                                   name="password"></input>
            <t id="forgot_pw" onClick={this.forgot_pw.bind(this)}>Forgot your password?</t>
            <div id="sure" className="g-recaptcha"></div>
            <input id="click_me" type="checkbox" style={{'display': 'none'}}/>
            
            <div style={{'marginTop': '20px'}} className="modal-footer">
              <button onClick={this.login_submit.bind(this)} type="button" className="btn btn-dark">Login</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
let widget_id;


// WEBPACK FOOTER //
// ./src/components/Login.js